import React, { useState } from "react";

const countries = [
  "Global Team",
  "Australia",
  "Brazil",
  "Bulgaria",
  "Canada",
  "Czech Republic",
  "Greece",
  "Greece (Research Team)",
  "Hungary",
  "Iceland",
  "Italy",
  "Kazakhstan",
  "Kyrgyzstan",
  "Latin America",
  "Latvia",
  "Malaysia",
  "Poland",
  "Portugal",
  "Republic of Moldova",
  "Romania",
  "Singapore",
  "Slovakia",
  "South Africa",
  "Spain",
  "Ukraine",
];

const contacts = {
  "Global Team": [
    {
      name: "Jan van der Merwe",
      email: "jan.van_der_merwe@boehringer-ingelheim.com",
    },
    { name: "Christopher Webb", email: "chris@wearetwelve.co.uk" },
    { name: "Darcy Kenna", email: "darcy@wearetwelve.co.uk" },
    { name: "Janine Dow", email: "janine@ctlcomms.com" },
    { name: "Beth Coezy", email: "bethanyc@ctlcomms.com" },
    { name: "Werner	Uys", email: "werner@lucan.tv" },
    { name: "Thomas Birch", email: "thomas@fastheroes.com" },
    { name: "Terrence Munodei", email: "terrence@fastheroes.com" },
    { name: "Alex	Talbot", email: "alex@fundraisingconsultants.co.uk" },
    { name: "Ethan Kuhn", email: "ethan@fundraisingconsultants.co.uk" },
  ],
  Australia: [
    { name: "Kim Malkin", email: "kim.malkin@boehringer-ingelheim.com" },
    {
      name: "Samantha	Dagasso",
      email: "samantha.dagasso@boehringer-ingelheim.com",
    },
  ],
  // Argentina: [
  //   { name: "Andrés Kusminsky", email: "andres@atrainlab.com" },
  //   { name: "Vicky Carrano", email: "victoria@atrainlab.com" },
  // ],
  Brazil: [
    { name: "Paula Ogawa", email: "paula.ogawa@boehringer-ingelheim.com" },
    {
      name: "Andrea	Giordano",
      email: "andrea.giordano@boehringer-ingelheim.com",
    },
  ],
  Bulgaria: [
    { name: "Elica Hadzhivalcheva", email: "elica@fastheroes112.com" },
    { name: "Dimitar Hadzhivalchev", email: "hadzhivalchev.dimitar@gmail.com" },
  ],
  Canada: [
    { name: "Keli Cristofaro", email: "keli.cristofaro@tbh.net" 
    }
  ],
  // Colombia: [
  //   { name: "Santiago Javier Luna", email: "santiago.luna@atrainlab.com" },
  // ],
  "Czech Republic": [
    { name: "Zuzana	Doležalová", email: "dolezalova@hm-institute.org" },
    { name: "Lucie Pražáková", email: "lucie.prazakova@fnusa.cz" },
    { name: "Simona	Kratochvílová", email: "simona.kratochvilova@zzskvk.cz" },
  ],
  Greece: [
    { name: "Lida	Papadopoulou", email: "lpapadopoulou@epidirect.gr" },
    { name: "Dimitra Kapetaniou", email: "dkapetaniou@epidirect.gr" },
    { name: "Eirini Chrysovalantou Agourzenidou", email: "info@epidirect.gr" },
  ],
  "Greece (Research Team)": [
    { name: "Hariklia	Proios", email: "hproios@gmail.com" },
    { name: "Maria	Baskini", email: "mariabaskini@gmail.com" },
    { name: "Kalliopi	Tsakpounidou", email: "kalliopi.020792@gmail.com" },
    { name: "Myrto Pyrrou", email: "mypyrrou@gmail.com " },
    { name: "Aimilia Orologa", email: "emiliaorologa@gmail.com" }
  ],
  Hungary: [
    { name: "Andrea Van den Aker", email: "andrea.kcskmt@gmail.com" },
    { name: "Peter Z. Wellisch", email: "peter.z.wellisch@gmail.com" },
  ],
  Iceland: [
    { name: "Birna Drofn Jonasdottir", email: "birna@athygli.is" },
    { name: "Bryndís Nielsen", email: "bryndis@athygli.is" },
  ],
  Italy: [
    { name: "Lidia Romagnuolo", email: "l.romagnuolo@aimcommunication.eu" },
    { name: "Mara	Cochetti", email: "m.cochetti@aimcommunication.eu" },
  ],
  Kazakhstan: [
    { name: "Assel Adayeva", email: "adaitaji@gmail.com" },
    { name: "Aiymkul Aliyeva", email: "ali_aiym@mail.ru" },
  ],
  Kyrgyzstan: [
    { name: "Dr Asel Kerimkulova", email: "kerimkulovaasel683@gmail.com" },
    { name: "Guzel Turdubaeva", email: "guzel.turdubaeva@mail.ru" },
  ],
  "Latin America": [
    { name: "Ariel Traverso", email: "ariel@atrainlab.com" },
    { name: "Santiago Luna", email: "santiago.luna@atrainlab.com" },
    { name: "Florencia Domínguez", email: "florencia@atrainlab.com" },
    { name: "Luis Seia", email: "luis@atrainlab.com" },
    { name: "Francisca Cortés-Monroy", email: "francisca@atrainlab.com" },
    { name: "Adriana Ortíz Garzón", email: "adriana@atrainlab.com" },
    { name: "Juan Sebastián Silva", email: "juanse@atrainlab.com" },
    { name: "Neolia Macchiaroli", email: "noelia@atrainlab.com" },
    { name: "Eloísa Arango Castro", email: "eloisa.arango@atrainlab.com" },
    { name: "Justo Scipioni", email: "justo@atrainlab.com" },
    { name: "Paola Ávalos", email: "paola@atrainlab.com" },
    { name: "Arturo Delgado", email: "arturo@atrainlab.com" },
  ],
  Latvia: [
    { name: "Mārtiņš Zvacki", email: "martins.zvackis@spkc.gov.lv" },
    { name: "Anna Aperga", email: "anna.sperga@spkc.gov.lv" },
    { name: "Maija Kalpiša", email: "maija.kalpisa@spkc.gov.lv" },
    { name: "Ilze Straume", email: "ilze.straume@spkc.gov.lv" }
  ],
  Malaysia: [
    { name: "Stephy Chan", email: "stephy.chan@boehringer-ingelheim.com" },
    { name: "Jacyleni Kirupanithi", email: "jacyleni.kirupanithi@edelman.com" },
    { name: "Jeslyn Teh", email: "jeslyn.teh@edelman.com" }
  ],
  Poland: [
    { name: "Dariusz Zieliński", email: "d.zielinski@primum.pl" },
    { name: "Gabriela Szkopek", email: "g.szkopek@primum.pl" },
    { name: "Dorota Niemczynowicz", email: "d.niemczynowicz@primum.pl" },
    { name: "Paulina Durakiewicz", email: "p.durakiewicz@primum.pl" }
  ],
  Portugal: [
    { name: "Joana Silva Rodrigues", email: "joana.silva@bcw-global.com" },
    { name: "Ana Ramos", email: "ana.ramos@bursonglobal.com" }
  ],
  "Republic of Moldova": [
    { name: "Diana Gavriluța", email: "diana.gavriluta19@gmail.com" },
    { name: "Natalia Ciobanu", email: "nataliaandronic@yahoo.com" }
  ],
  Romania: [
    { name: "Bogdan Alecu", email: "bogdan@thesocialnest.ro" },
    { name: "Vlad Mihailescu", email: "vlad@thesocialnest.ro" },
    { name: "Silvia Novac", email: "silvia@thesocialnest.ro" }
  ],
  Singapore: [
    { name: "Stephy Chan", email: "stephy.chan@boehringer-ingelheim.com" },
    { name: "Dominique Koh", email: "dominique@preschoolmarket.com" },
    { name: "Xiang Ping Tan", email: "xiangping@preschoolmarket.com" }
  ],
  Slovakia: [
    { name: "Lubica Fidesová", email: "lubica.fidesova@grapepr.sk" }
  ],
  "South Africa": [
    { name: "Renathe van der Merwe", email: "renathe.vandermerwe@iqvia.com" },
    { name: "Kaylyn Dodd", email: "kaylyndodd@gmail.com" }
  ],
  Spain: [
    { name: "Pancho López Garbayo", email: "franciscolopez@airun.cat" },
    { name: "Roger Piera", email: "rogerpiera@airun.cat" }
  ],
  Ukraine: [
    { name: "Anastasiia Klysakova", email: "aklysakova@onehealth.com.ua" },
    { name: "Natali Olbert", email: "nolbert@onehealth.com.ua" },
    { name: "Alina Dziubko", email: "adziubko@onehealth.com.ua" }
  ],
};

const CountrySelector = () => {
  const [selectedCountry, setSelectedCountry] = useState("");

  const handleCountryChange = (event) => {
    setSelectedCountry(event.target.value);
  };

  return (
    <div className="countrySelector">
      <select value={selectedCountry} onChange={handleCountryChange}>
        <option value="">Select your country</option>
        {countries.map((country) => (
          <option key={country} value={country}>
            {country}
          </option>
        ))}
      </select>
      <div>
        {selectedCountry && (
          <>
            <div className="contactsReturned">
              <h3>Contacts in {selectedCountry}</h3>
              {contacts[selectedCountry] ? (
                contacts[selectedCountry].map((contact) => (
                  <div className="contactDetails" key={contact.email}>
                    <strong>{contact.name}</strong>: <br />
                    <a href={`mailto:${contact.email}`}>{contact.email}</a>
                  </div>
                ))
              ) : (
                <p>No contacts available for this country</p>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CountrySelector;
